import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PageLoader } from '@sumtotal/react-foundation';
import authService, { AuthenticationResultStatus } from './AuthorizeService';
import { LoginActions, QueryParameterNames } from './AuthorizationConstants';

const LoginContainer = styled.div`
  text-align: center;
`;

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { message: undefined };
  }

  componentDidMount() {
    const { action } = this.props;
    switch (action) {
      case LoginActions.Login:
        this.login(this.getReturnUrl());
        break;
      case LoginActions.LoginCallback:
        this.processLoginCallback();
        break;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }

  getReturnUrl = (state) => {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get(QueryParameterNames.ReturnUrl);
    if (fromQuery && !fromQuery.startsWith(`${window.location.origin}/`)) {
      // This is an extra check to prevent open redirects.
      throw new Error(
        'Invalid return url. The return url needs to have the same origin as the current page.'
      );
    }
    return (state && state.returnUrl) || fromQuery || `${window.location.origin}/`;
  };

  redirectToApiAuthorizationPath = (apiAuthorizationPath) => {
    const redirectUrl = `${window.location.origin}${apiAuthorizationPath}`;
    // It's important that we do a replace here so that when the user hits the back arrow on the
    // browser he gets sent back to where it was on the app instead of to an endpoint on this
    // component.
    window.location.replace(redirectUrl);
  };

  navigateToReturnUrl = (returnUrl) => {
    // It's important that we do a replace here so that we remove the callback uri with the
    // fragment containing the tokens from the browser history.
    window.location.replace(returnUrl);
  };

  async login(returnUrl) {
    const state = { returnUrl };
    const result = await authService.signIn(state);
    switch (result.status) {
      case AuthenticationResultStatus.Redirect:
        break;
      case AuthenticationResultStatus.Success:
        await this.navigateToReturnUrl(returnUrl);
        break;
      case AuthenticationResultStatus.Fail:
        this.setState({ message: result.message });
        break;
      default:
        throw new Error(`Invalid status result '${result.status}'`);
    }
  }

  async processLoginCallback() {
    const url = window.location.href;
    const result = await authService.completeSignIn(url);

    switch (result.status) {
      case AuthenticationResultStatus.Redirect:
        throw new Error('Should not redirect.');
      case AuthenticationResultStatus.Success:
        await this.navigateToReturnUrl(this.getReturnUrl(result.state));
        break;
      case AuthenticationResultStatus.Fail:
        this.setState({ message: result.message });
        break;
      default:
        throw new Error(`Invalid authentication result status '${result.status}'.`);
    }
  }

  render() {
    const { action } = this.props;
    const { message } = this.state;

    if (message) {
      return <LoginContainer>{message}</LoginContainer>;
    }
    switch (action) {
      case LoginActions.Login:
        return <PageLoader show />;
      case LoginActions.LoginCallback:
        return <PageLoader show />;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }
}

Login.propTypes = {
  action: PropTypes.string.isRequired
};
